module.exports = __webpack_public_path__ + "img/khadem-al-qubaisi.8d38a98a.png";